export default __webpack_public_path__ + "static/media/Screenshot (17).381b4d13.png";